// Copyright (c) Ensho Health, 2021 to present

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import actions from '../../state-manager/action';
import { ROUTES } from '../../constants.js';
import FormChallenge from '../../component/reset-password/FormChallenge.js';
import FormResetPassword from '../../component/reset-password/FormResetPassword.js';

import { StyledPage, StyledError } from './ResetPassword.styles.js';

const ForgotPassword = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  function onBack() {
    history.push(ROUTES.LOGIN);
  }

  async function onSubmitChallenge(info) {
    try {
      dispatch(actions.auth.sendRecoveryAnswer(info));
    } catch (error) {
      setErrorMessage(error.message);
    }
  }
  async function onSubmitResetPassword(info) {
    try {
      dispatch(actions.auth.resetPassword(info));
    } catch (error) {
      setErrorMessage(error.message);
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const recoveryToken = params.get('token');
    if (recoveryToken) {
      dispatch(actions.auth.verifyRecoveryToken({ recoveryToken }));
    } else {
      history.push(ROUTES.LOGIN);
    }
  }, [dispatch, history, location]);

  useEffect(() => {
    if (auth.transaction) {
      dispatch(actions.auth.handleNewTransaction());
    }
  }, [dispatch, auth.transaction]);

  const displayErrorMessage = errorMessage ? true : false;
  const displayChallengeForm =
    !displayErrorMessage &&
    (!auth.transaction || auth.transaction?.status === 'RECOVERY');
  const pushSent = ['MFA_CHALLENGE', 'SUCCESS'].includes(
    auth.transaction?.status
  );
  const displayResetPasswordForm =
    !displayErrorMessage &&
    ['SUCCESS', 'PASSWORD_RESET', 'MFA_CHALLENGE', 'MFA_REQUIRED'].includes(
      auth.transaction?.status
    );

  return (
    <StyledPage>
      {displayErrorMessage && <StyledError>{errorMessage}</StyledError>}
      {displayChallengeForm && (
        <FormChallenge
          onSubmit={onSubmitChallenge}
          loading={auth.loading}
          recoveryQuestion={auth.transaction?.user.recovery_question.question}
          errorMessage={errorMessage || auth.error}
        />
      )}
      {displayResetPasswordForm && (
        <FormResetPassword
          onSubmit={onSubmitResetPassword}
          loading={auth.loading}
          errorMessage={errorMessage || auth.error}
          onBack={onBack}
          pushSent={pushSent}
        />
      )}
    </StyledPage>
  );
};

export default ForgotPassword;
